<template>
  <form @submit.prevent="save()">
    <div class="main-header">
      <h3>{{this.$route.params.id>0?$t('admin.addrole.modification'):$t('admin.addrole.new')}}{{$t('admin.addrole.account_role')}}</h3>
      <button type="submit">{{$t('global.save')}}</button>
    </div>
    <div class="form-field">
      <section>
        <span>{{$t('admin.common.role_group_name')}}</span>
        <input type="text" v-model="role.name">
      </section>
      <section>
        <span>{{$t('admin.addrole.copyright_explain')}}</span>
        <textarea v-model="role.description" ></textarea>
      </section>
      <section>
        <span>{{$t('admin.addrole.edit_permission')}}</span>
        <div class="sel-module">
          <tree1 :data="pages" :show-checkbox="true" :default-expand-all="true"
                   :props="defaultProps" v-model="checkedPages"></tree1>
        </div>
      </section>
    </div>
  </form>
</template>

<script>
  export default {
    components:{},
    data () {
      return {
        role:{
          name:'',
          description:'',
          pages:[]
        },
        idMap:{},
        modules:[],
        pages:[],
        checkedPages:[],
        defaultProps: {
          children: 'children',
          label: 'label'
        }
      }
    },
    watch:{
      pages:{
        handler:function(){
        },
        deep:true
      }
    },
    computed:{
    },
    methods:{
      save () {
        this.role.pages = this.checkedPages
        this.$http.post('/ams/role/save',JSON.stringify(this.role)).then(()=>{
          // window.alert(this.$t('global.save'))
          this.$notify({
            title: 'Success',
            message: '保存成功',
            type: 'success'
          })
          this.$router.push('/ams/admin/role/list')
        })
      },
      select(item,val){
        function ck(data,c) {
          data.checked = c
          if(data.children&&data.children.length>0){
            data.children.forEach(v=>{
              if(v.children){
                ck(v,c)
              }
              v.checked = c
            })
          }
        }
        ck(item,val)
      },
      getPages () {
        this.$http.get('/ams/page/list').then(res=> {
          this.pages = res.data.data
        });
      },
      getDetail () {
        if(this.$route.params.id){
          this.$http.get('/ams/role/detail',{params:{id:this.$route.params.id}}).then(res=>{
            this.role = res.data.data
            this.checkedPages = Object.assign([],this.role.pages);
          })
        }else{
          this.role = {name:'', description:'', pages:[] }
          this.checkedPages = []
        }

      }
    },
    mounted() {
      this.getPages();
      if(this.$route.params.id>0) {
        this.getDetail();
      }
    }
  }

</script>

<style lang="less" scoped>
.sel-module{
  display: inline-block;
  max-width:650px!important;
}
.cell{
  font-weight: bold;
  .cell{
    font-weight: normal;
    padding-left: 30px;
    border-left: 1px solid #acacac;
    position: relative;
    line-height: 30px;
    margin-left: 8px;
  }
}
.cell .cell div:first-child::before{
  content: '';
  width: 28px;
  height: 1px;
  background: #acacac;
  position: absolute;
  left: 0;
  top: 15px
}
</style>
<style>
  .el-tree-node__children .is-leaf {
    display:inline-block;
  }
  .el-tree-node {
    white-space: normal!important;
  }
</style>
